import React from 'react';
import Header from './Header';
import Hero from './Hero';
import Testimonials from './Testimonials';
import TrustStats from './TrustStats';
import OurWork from './OurWork';
import Services from './Services';
import ProcessSection from './ProcessSection';
import FAQ from './FAQ';
import QuoteCTA from './QuoteCTA';
import Footer from './Footer';
import StickyFooterBar from './StickyFooterBar';
import { ServiceEnquiryProvider } from './ServiceEnquiry';
import useScrollReveal from '../hooks/useScrollReveal';

function PageBody() {
  useScrollReveal();
  return (
    <div className="App min-h-screen bg-[#f7f6f2] text-[#16150f]">
      <Header />
      <main>
        <Hero />
        <OurWork />
        <TrustStats />
        <Testimonials />
        <Services />
        <ProcessSection />
        <FAQ />
        <QuoteCTA />
      </main>
      <Footer />
      <StickyFooterBar />
    </div>
  );
}

export default function HomePage() {
  return (
    <ServiceEnquiryProvider>
      <PageBody />
    </ServiceEnquiryProvider>
  );
}
